export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حقول النموذج رقم"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الهوية المطلوبة مفقودة"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لقد قمت بتسجيل الدخول بنجاح، تابع العمليات في ماكينة الصراف الآلي"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متابعة معاملات الصراف الآلي"])}
}